/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo, useState } from 'react';
import { t } from '@lingui/macro';
import { isObject } from 'lodash';
import useIsPrinting from '../../utilities/PrintUtilities';

const IPItem = ({ item }) => {
    if (isObject(item)) {
        return (
            <>
                {item.ipAddress}
                {item.loopback && (
                    <small>
                        <strong>{t` (loopback)`}</strong>
                    </small>
                )}
            </>
        );
    }
    return item;
};
/**
 * Expandable IP Addresses list component. It expects props.value to be an array of objects with
 * ipAddress (string) and loopback (boolean) properties.
 * @param props
 * @returns {*}
 * @constructor
 */
export default function PropertiesIpAddressList(props) {
    const { value, maxLines = 10 } = props;
    const [expanded, setExpanded] = useState(false);
    const isPrinting = useIsPrinting();
    return useMemo(() => {
        return (
            <div>
                {value.slice(0, expanded || isPrinting ? value.length : maxLines).map((item, index) => (
                    <div key={`${index}`}>
                        <IPItem item={item} />
                    </div>
                ))}
                {maxLines < value.length && !expanded && !isPrinting && (
                    <a href="#" onClick={() => setExpanded(true)}>
                        {`Show ${value.length - maxLines} more...`}
                    </a>
                )}
            </div>
        );
    }, [expanded, maxLines, value, isPrinting]);
}
